import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, BaseStyles } from "@primer/react";

import "@primer/primitives/dist/css/functional/themes/light.css";

import Home from "./components/Home/index";

function App() {
  return (
    <ThemeProvider colorMode="light">
      <BaseStyles fontFamily="SF Pro Text, sans-serif" color="#333">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:slug" element={<Home />} />
          </Routes>
        </Router>
      </BaseStyles>
    </ThemeProvider>
  );
}

export default App;
